import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

var _richTextStyles;
/*
We want the first child, and the first child of the first child, and the first child of the first child of the first child, and so on, to have no top margin.

> *:first-child,
> *:first-child > *:first-child,
> *:first-child > *:first-child > *:first-child,

also to skip the module marker
> script:first-child + *,
> script:first-child + * > *:first-child,
> script:first-child + * > *:first-child > *:first-child,
*/

var DEPTH = 5;
var generateSelector = function generateSelector(level) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '> *:first-child';
  var firstSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : selector;
  return Array(level).fill().map(function (_, i) {
    return Array(i + 1).fill().map(function (_, j) {
      return j === 0 ? firstSelector : selector;
    }).join(' ');
  }).join(', ');
};
var richTextStyles = (_richTextStyles = {}, _defineProperty(_richTextStyles, generateSelector(DEPTH, '> *:first-child'), {
  mt: 0
}), _defineProperty(_richTextStyles, generateSelector(DEPTH, '> *:first-child', '> script:first-child + *'), {
  mt: 0
}), _defineProperty(_richTextStyles, generateSelector(DEPTH, '> *:last-child'), {
  mb: 0
}), _richTextStyles);

export { richTextStyles as default };
